"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.inn = exports.VALIDATION_INN = void 0;
exports.VALIDATION_INN = 'validators:inn';
var checkInnStep = function (inn, lastIndex) {
    var weights = [3, 7, 2, 4, 10, 3, 5, 9, 4, 6, 8];
    var sum = inn
        .slice(0, lastIndex)
        .reduce(function (result, digit, i) { return result + digit * weights[i + weights.length - lastIndex]; }, 0);
    return (sum % 11) % 10 === inn[lastIndex];
};
var isValidInn = function (value) {
    var inn = value
        .trim()
        .split('')
        .map(function (ch) { return parseInt(ch, 10); });
    if (inn.length === 12) {
        return checkInnStep(inn, 10) && checkInnStep(inn, 11);
    }
    if (inn.length === 10) {
        return checkInnStep(inn, 9);
    }
    return false;
};
var inn = function (key) {
    if (key === void 0) { key = exports.VALIDATION_INN; }
    return function (value) {
        return value && !isValidInn(value) ? { key: key, options: {} } : false;
    };
};
exports.inn = inn;
//# sourceMappingURL=inn.js.map